import GradientStop from './gradient-stop';

/**
 * Represents a radial gradient
 */
export default class RadialGradient {
  cx = 50;
  cy = 50;
  /**
   * @type GradientStop[]
   */
  stops = [];

  /**
   *
   * @param {SVGRadialGradientElement|undefined} element
   */
  constructor (element) {
    if (element) {
      this.parseElement(element);
    } else {
      const stop1 = new GradientStop();
      const stop2 = new GradientStop();
      stop2.offset = 100;
      stop2.color = '#87CEEB'; // skyblue
      this.stops = [stop1, stop2];
    }
  }

  /**
   *
   * @param {SVGRadialGradientElement} element
   */
  parseElement (element) {
    const me = this;
    ['cx', 'cy'].forEach(attribute => {
      me[attribute] = parseFloat(element.getAttribute(attribute)) || 0;
    });

    this.stops = [];
    const stopElements = element.querySelectorAll('stop');
    stopElements.forEach(stopElement => {
      this.stops.push(new GradientStop(stopElement));
    });
  }

  /**
   * Copy current object to this element (stops must be copied separately)
   * @param {SVGRadialGradientElement} radialGradientElement
   */
  toElement (radialGradientElement) {
    const me = this;
    ['cx', 'cy'].forEach(attribute => {
      radialGradientElement.setAttribute(attribute, me[attribute] + '%');
    });
  }
}
